@if (!hidden()) {
  <div class="address" tabindex="-1" (click)="focus()" (keydown)="(null)">
    @if (label(); as label) {
      <onyx-input-label
        [label]="label"
        [hint]="hint()"
        [disabled]="disabled()"
        [required]="required() && showRequired()"
      ></onyx-input-label>
    }

    <div
      class="input size-{{ size() }}"
      [class.active]="value()"
      [class.disabled]="disabled()"
      [class.invalid]="isInvalid()"
      [onyxDropdownOptions]="addresses$ | async"
      [onyxDropdownValue]="value()"
      [onyxDropdownDisabled]="disabled()"
      [(onyxDropdownAttached)]="expanded"
      [onyxDropdownFilter]="false"
      [(onyxDropdownQuery)]="query"
      [onyxDropdownNotFoundMessage]="notFoundMessage()"
      [onyxDropdownLoading]="loading()"
      [onyxDropdownShowAddOption]="showAddOption()"
      [onyxDropdownAddOptionMessage]="addOptionMessage()"
      [onyxDropdownSubheadingTemplateRef]="subheadingTemplate"
      [onyxDropdownOptionTemplateRef]="optionTemplate"
      onyxDropdownWidth="inherit"
      (onyxDropdownSelectedValueChange)="changeValue($event.value)"
      (onyxDropdownAttachedChange)="$event ? null : restoreOnFocusout()"
      (onyxDropdownAddOption)="addOption.emit($event)"
      (onyxDropdownFocus)="focus()"
    >
      <input
        [value]="inputValue()"
        [placeholder]="placeholder() | translate"
        [disabled]="disabled()"
        (input)="changeQuery($event)"
        #inputElement
      />

      <div class="actions">
        <div class="hidden">
          @if (value() && !disabled()) {
            <onyx-clear-button
              (click)="clearValue(); $event.stopPropagation()"
            ></onyx-clear-button>
          }
        </div>

        @if (showPicker()) {
          <onyx-icon-button
            variant="transparent"
            color="blue"
            [size]="24"
            icon="location-outlined"
            [disabled]="disabled()"
            [tabindex]="-1"
            (click)="openPicker(); $event.stopPropagation()"
          ></onyx-icon-button>
        }
      </div>
    </div>

    @let control = formField() ?? formControl();
    @if (control && showErrors()) {
      <onyx-error [errors]="[control]" variant="control"></onyx-error>
    }
  </div>

  @if (showApartment()) {
    <onyx-text-field
      [size]="size()"
      [label]="`${I18N}.apartment`"
      [width]="apartmentWidth()"
      [(value)]="apartmentNumber"
      [disabled]="disabled()"
      [showErrors]="showErrors()"
    ></onyx-text-field>
  }
}

<ng-template #subheadingTemplate>
  <p class="header f-label-m">
    {{ subheading() | translate }}
  </p>
</ng-template>

<ng-template let-option="option" let-query="query" #optionTemplate>
  <div class="option">
    @switch (option.value.type) {
      @case (OnyxAddressType.POINT_OF_INTEREST) {
        <onyx-icon
          class="point-of-interest"
          name="menu-poi-outlined"
          [size]="16"
        ></onyx-icon>
      }
      @default {
        <onyx-icon name="location-filled" [size]="16"></onyx-icon>
      }
    }

    @let poiName = option.value.poiName;
    @let labelName = poiName ?? option.value.name;
    @let label = `${labelName ? `${labelName}, ` : ''}${option.name}`;
    <p
      [onyxTooltip]="label"
      [onyxTooltipDisabled]="
        overflowHelper.hasNoOverflow.bind(overflowHelper, labelElement)
      "
      #labelElement
    >
      @if (labelName) {
        <span
          [class.f-body-m]="poiName"
          [class.f-medium]="poiName"
          [innerHTML]="labelName | onyxHighlight: query"
        ></span
        >{{ poiName ? ' ' : ', ' }}
      }
      <span [innerHTML]="option.name | onyxHighlight: query"></span>
    </p>
  </div>
</ng-template>
